<template>
  <div>
    <Message v-if="updateIssued">
      {{ $t('features.long_term.explainer.setting_updating') }}
    </Message>

    <p class="text-muted">{{ $t('global.setting', 2) }}</p>

    <i18n-t
      keypath="features.long_term.explainer.setting_description"
      tag="div"
    >
      <template #date>
        <strong>{{ period.getDateStartString() }}</strong>
      </template>
      <template #setting>
        <strong> {{ period.getPromisedTotal().toString() }} </strong>
      </template>
    </i18n-t>

    <long-term-period-settings-dialog :period="period" :company="company" />
  </div>
</template>

<script lang="ts">
import Company from '@/domain/model/business/Company';
import YieldPromiseStatus from '@/domain/model/business/YieldPromiseStatus.ts';
import LongTermPeriodSettingsDialog from '@/presentation/components/long-term-period/LongTermPeriodSettingsDialog.vue';

export default {
  name: 'LongTermPeriodSettings',
  components: { LongTermPeriodSettingsDialog },
  props: {
    period: { type: YieldPromiseStatus, required: true },
    company: { type: Company, required: true },
  },
  data() {
    return {
      updateIssued: false,
    };
  },
};
</script>

<style scoped></style>
